import { DisplayField, InputField } from '@/components/ui/DynamicTechTaskCard/types'
import { Response } from '@/types/requests-types'


export enum CardState {
    FORM_LOADING = 'FORM_LOADING',
    FORM_ERROR = 'FORM_ERROR',
    READY = 'READY',
    LOADING = 'LOADING',
    ERROR = 'ERROR'
}


export interface TechTaskState {
    taskName: string|null;
    cardState: CardState;
    message: string|null;
    form: FormData|null;
    inputData: { [key: string]: unknown };
    displayData: { [key: string]: unknown }|null;
}


export interface SetInputData extends Response {
    key: string;
    value: unknown;
}


export interface FormBehavior {
    loadData: string[]|null;
}


export interface FormData {
    inputFields: InputField[];
    displayFields: DisplayField[];
    behavior: FormBehavior;
}


export interface FormResponse extends Response {
    data: FormData;
}


export interface LoadFormDataResponse extends Response {
    data: { [key: string]: unknown };
}
